// THIS FILE WAS GENERATED BY A SCRIPT AND SHOULD NOT BE UPDATED MANUALLY
import "@react-md/core/icon/configureMaterialSymbols";
